/* global ScrollMagic theme */

import respResize from './respResize';

var topMenu = { 
    initialized: false,
    menu: null, 
    scene: null,
    hm: null, // hamburger menu switch
    init: function () {
        var me = topMenu, m;
        me.menu = m = $('#tmenu');
        $('#main-wr').append(m.clone().attr('id', 'hm-content-menu'));
        me.hm = $('#hm-menu');
        if ( !m.length ) return false;
        $('#tmenu > li.no-click > a').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
        });
        me.hm.click( function (e) {
            var m = $('#hm-content-menu');
            if ( me.hm.hasClass('open') ) {
                m.stop().removeClass('open');
                me.hm.stop().removeClass('open');
                $('body').removeClass('noScroll');
            } else {
                me.hm.stop().addClass('open');
                m.stop().addClass('open');
                $('body').addClass('noScroll');
            }
        });

        m.find('> li').each( function (i, e) {
            var $li = $(e);
            $li.hoverIntent({
                over: () => {
                    $li.addClass('hover');
                },
                out: () => {
                    $li.removeClass('hover');
                },
                interval: 30,
                timeout: 300
            });
        });
        $('#tmenu > li > a').on('touchend', (e) => {
            var $me = $(e.currentTarget).parent();
            $('#tmenu > li').not($me).removeClass('hover');
            if ( $me.hasClass('menu-item-has-children')) {
                $me.toggleClass('hover');
                e.stopPropagation();
                e.preventDefault();
            } 
        });
        m.find('> li > a').hammer().on('press', (e) => { 
            window.location = e.currentTarget.href;
        });
      
        $(document).on('changeMobile', topMenu.changeMobile);
        $(document).on('changeBreakpoint', topMenu.changeBreakpoint);
        me.changeMobile();
    },
    
    changeBreakpoint: () => {
        var me = topMenu;
        if ( me.scene ) {
            topMenu.scene.offset($('#header').height())
                .refresh();
        }
    },
    
    changeMobile: () => {
        var me = topMenu;
        $('#hm-content-menu').stop().removeClass('open');
        $('#hm-menu').stop().removeClass('open');
        if ( respResize.isMobile() ) {
            if ( me.scene ) {
                me.scene.destroy(true);
                me.scene = null;
            }
        } else {
            if ( me.scene ) {
            } else {
                me.scene = new ScrollMagic.Scene({
                        reverse: true,
                        offset: $('#header').height()
                    })
                    .setPin("#tmenu-row")
                    .setClassToggle("#tmenu-row", 'pined')
                    .addTo(theme.scrollController);
            }
        }
    }
};
export default topMenu;
